import React, { useCallback, useState } from "react";
import "./MobileHeader.scss";
import { Link, useLocation } from "react-router-dom";
import { ReactComponent as Logo } from "../../../static/icons/logo-SaveOffice.svg";
import { performConversionScript } from "../../../shared/ConversionHelper";

const MobileHeader = () => {
  const headerRef = React.useRef<any>(null);
  const [headerCollapse, setHeaderCollapse] = useState(false);
  const [collapse, setCollapse] = useState(true);
  const collapseRef = React.useRef(collapse);

  const toggleCollapse = useCallback(() => {
    setCollapse((prev) => !prev);
  }, []);
  const location = useLocation();
  const logoPath = "/";
  const privateOfficeLinkTarget = "/private-office";

  React.useEffect(() => {
    collapseRef.current = collapse;

    if (!collapse && headerRef.current) {
      headerRef.current.style.position = "fixed";
      headerRef.current.style.marginBottom = "0";
    }
  }, [collapse]);

  React.useEffect(() => {
    let scrollY = window.scrollY;

    function onScroll() {
      if (!headerRef.current || !collapseRef.current) {
        return;
      }

      if (window.scrollY > scrollY) {
        headerRef.current.style.position = "static";
        headerRef.current.style.marginBottom = "-56px";
        setHeaderCollapse(true);
      } else {
        setHeaderCollapse(false);
        headerRef.current.style.position = "fixed";
        headerRef.current.style.marginBottom = "0";
      }

      scrollY = window.scrollY;
    }

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <header
        ref={headerRef}
        className={`mobile-header ${collapse ? "collapse_" : "expand_"} ${
          headerCollapse ? "header-collapse" : ""
        }`}
        id={"mobile-header"}
      >
        <div className="gnb">
          <Link
            to={logoPath}
            className="logo"
            onClick={() => window.scrollTo({ top: 0 })}
          >
            <Logo width={134} />
          </Link>
          <button onClick={toggleCollapse} className="menu-toggle">
            <div className="toggle-icon">
              <span />
              <span />
            </div>
          </button>
        </div>
        <nav className="mobile-nav">
          <ul>
            {/* <a href="/offer" onClick={toggleCollapse}>
              <li>제공 서비스</li>
            </a> */}
            <a href="/benefits" onClick={toggleCollapse}>
              <li>베네핏 서비스</li>
            </a>
            <a href="/price" onClick={toggleCollapse}>
              <li>비용 안내</li>
            </a>
            <a href="/manual" onClick={toggleCollapse}>
              <li>이용 방법</li>
            </a>
            <a href="/union" onClick={toggleCollapse}>
              <li>결합 서비스</li>
            </a>
            <Link to="/promotion" onClick={toggleCollapse}>
              <li>프로모션</li>
            </Link>
            <Link to="/faq" onClick={toggleCollapse}>
              <li>자주 묻는 질문</li>
            </Link>
          </ul>
          <ul>
            <Link to={privateOfficeLinkTarget} onClick={toggleCollapse}>
              <li>
                <img src={require("../../../static/office2.png")} />
                상주 사무실
              </li>
            </Link>
          </ul>
          <ul>
            <Link to="/location">
              <li>
                <img src={require("../../../static/location2.png")} />
                위치 안내
              </li>
            </Link>
          </ul>
          <ul>
            <Link
              to={`/consult${location.search}`}
              onClick={performConversionScript}
            >
              <li>
                <img src={require("../../../static/message2.png")} />
                지금 신청하기
              </li>
            </Link>
          </ul>
        </nav>
      </header>
      <div
        className={`mobile-header-overlay ${collapse ? "" : "visible"}`}
        onClick={toggleCollapse}
      />
    </>
  );
};

export default MobileHeader;
